import '@fortawesome/fontawesome-free/css/all.min.css';
import { CssBaseline } from '@mui/material';
import { GoogleOAuthProvider } from '@react-oauth/google';
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import i18n from './i18n';
import App from './App';

import { CLIENT_ID_GOOGLE_SSO } from 'constants/api';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import ThemeProviderCustom from 'ThemeProviderCustom';
import './index.css';
import './responsive.css';
import store from './store/store';
import { migratePersistedStorage } from './store/persistence';
import { clearTokens } from './utils/cookies';

if (migratePersistedStorage()) {
    clearTokens();
}
let persistor = persistStore(store);

ReactDOM.render(
    <React.StrictMode>
        <GoogleOAuthProvider
            clientId={CLIENT_ID_GOOGLE_SSO}
            onScriptLoadSuccess={(e) => { }}
            onScriptLoadError={(e) => { }}
        >
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <ThemeProviderCustom>
                        <CssBaseline />
                        <I18nextProvider i18n={i18n}>
                            <App />
                        </I18nextProvider>
                    </ThemeProviderCustom>
                </PersistGate>
            </Provider>
        </GoogleOAuthProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);
